import React from 'react';
import PropTypes from 'prop-types';
import { localizeJsonLD } from './helper';
import { SettingsContext } from '../../hoc/Settings';
import { LocalizationContext } from '../../hoc/Localization';

const JsonLD = ({ type, data }) => {
  const { locale } = React.useContext(LocalizationContext);

  const mainData = localizeJsonLD(data);
  const {
    domainSettings: { domain },
  } = React.useContext(SettingsContext);

  if (!mainData.id) {
    return null;
  }

  switch (type) {
    case 'event':
      return <script type="application/ld+json" />;
    case 'front':
      return (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              url: `https://${domain}/`,
              potentialAction: {
                '@type': 'SearchAction',
                target: `https://${domain}/${locale}/search?search={search_term_string}`,
                'query-input': 'required name=search_term_string',
              },
              '@graph': [
                {
                  '@context': 'https://schema.org',
                  '@type': 'SiteNavigationElement',
                  '@id': '#table-of-contents',
                  name: 'Blog',
                  url: `https://${domain}/en/blog`,
                },
                {
                  '@context': 'https://schema.org',
                  '@type': 'SiteNavigationElement',
                  '@id': '#table-of-contents',
                  name: 'About us',
                  url: `https://${domain}/en/about`,
                },
                {
                  '@context': 'https://schema.org',
                  '@type': 'SiteNavigationElement',
                  '@id': '#table-of-contents',
                  name: 'Course Finder',
                  url: `https://${domain}/en/search`,
                },
              ],
            }),
          }}
        />
      );
    default:
      return false;
  }
};

JsonLD.propTypes = {
  type: PropTypes.oneOf(['event', 'front']),
  data: PropTypes.object,
};

JsonLD.defaultProps = {
  data: {},
};

export default JsonLD;
